import { Responsable, Stage, Product, StagePrice, ProductPrice } from "./classes.catalogsformations";
import { ConnectedUser } from 'projects/lib-components/src/public_api';
import { WSUserRole } from './generic.data';

export class ProspectBase {
  public UserRole: WSUserRole;
  public ExtranetUser: ConnectedUser;
  RaisonSo: string;
  Civilite: string;
  Nom: string;
  Prenom: string;
  Adr1: string;
  Adr2: string;
  Adr3: string;
  CodePostal: string;
  Ville: string;
  NumTel: string;
  FixTel: string;
  Email: string;
  SiteWeb: string;
  Info: string;
  MotDePasse: string;

  constructor() {
    this.RaisonSo = '';
    this.Civilite = '';
    this.Nom = '';
    this.Prenom = '';
    this.Adr1 = '';
    this.Adr2 = '';
    this.Adr3 = '';
    this.CodePostal = '';
    this.Ville = '';
    this.NumTel = '';
    this.FixTel = '';
    this.Email = '';
    this.SiteWeb = '';
    this.Info = '';
    this.MotDePasse = '';
  }
}

export class ProspectInfo extends ProspectBase {
  ProduitId: string;
  NomProduit: string;
  CodeProduit: string;
  Prix_Product: ProductPrice ;
  ResponsablesList: Responsable[];
  //////ProspectOptionalFields: Array<OptionalForm>;
  //////ContactOptionalFields: Array<OptionalForm>;

  constructor() {
    super();

    this.ProduitId = '';
    this.NomProduit = '';
    this.CodeProduit = '';
    this.ResponsablesList = [];
    //////this.ProspectOptionalFields = [];
    //////this.ContactOptionalFields = [];
  }
}

export class ProspectCycle extends ProspectBase {
  IdentCycle: string;
  CycleName: string;
  NumCycle: string;
  Prix_Cycle: string;
  ListStage: Stage[];
  ResponsablesList: Responsable[];
  //////ProspectOptionalFields: Array<OptionalForm>;
  //////ContactOptionalFields: Array<OptionalForm>;

  constructor() {
    super();

    this.IdentCycle = '';
    this.CycleName = '';
    this.NumCycle = '';
    this.Prix_Cycle = '';
    this.ListStage = [];
    this.ResponsablesList = [];
    //////this.ProspectOptionalFields = [];
    //////this.ContactOptionalFields = [];
  }
}

export class ProspectStage extends ProspectBase {
  IdentStage: string;
  StageName: string;
  NumStage: string;
  Prix_Stage: StagePrice;
  StageProduct: Product;
  ResponsablesList: Responsable[];
  //////ProspectOptionalFields: Array<OptionalForm>;
  //////ContactOptionalFields: Array<OptionalForm>;

  constructor() {
    super();

    this.IdentStage = '';
    this.StageName = '';
    this.NumStage = '';
    this.StageProduct = new Product();
    this.ResponsablesList = [];
    //////this.ProspectOptionalFields = [];
    //////this.ContactOptionalFields = [];
  }
}

